<template>
  <nav class="breadcrumb" aria-label="breadcrumbs" v-if="!login_page">
    <ul>
      <template v-for="(link, index) in links">
        <li :key="index">
          <router-link :to="{ path: link.path }">
            <span v-if="link.page_title">{{ title }}</span>
            <span v-else-if="link.server_name_title">{{ server_name }}</span>
            <span v-else-if="link.list_name_title">{{ list_name_title }}</span>
            <span v-else-if="link.dashboard_name_title">{{ dashboard_name }}</span>
            <span v-else-if="link.ui_element_name_title">{{ ui_element_name }}</span>
            <span v-else>{{ link.title }}</span>
          </router-link>
        </li>
      </template>
    </ul>
  </nav>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapUserState } = createNamespacedHelpers('general')
export default {
  name: 'Breadcrumb',
  computed: {
    ...mapUserState({
      title: state => state.title,
      server_name: state => state.server_name,
      dashboard_name: state => state.dashboard_name,
      ui_element_name: state => state.ui_element_name,
      list_name_title: state => state.list_name_title
    }),
    login_page() {
      return this.$route.meta.layout == 'login'
    },
    links() {
      return this.$lodash.reduce(
        this.$route.matched,
        (acc, link) => {
          if (link.meta.breadcrumbs) {
            const breadcrumbs =
              typeof link.meta.breadcrumbs === 'function' ? link.meta.breadcrumbs.apply(this) : link.meta.breadcrumbs

            acc.push(...breadcrumbs)
          } else {
            acc.push({
              path: link.path,
              title: link.meta.title[this.$i18n.locale].title,
              isActive: this.$route.name === link.name
            })
          }
          return acc
        },
        []
      )
    }
  }
}
</script>

<style scoped lang="scss"></style>
